import common from './common';
import onboarding from './onboarding';
import landing from './landing';
import camp from './camp';
import map from './map';
import prepare from './prepare';
import report from './report';
import survivor from './survivor';
import skills from './skills';
import inventory from './inventory';
import workshop from './workshop';
import feed from './feed';
import horde from './horde';
import encounter from './encounter';
import clan from './clan';
import story from './story';
import settings from './settings';
import events from './events';
import collection from './collection';
import session from './session';
import history from './history';
import privacy from './privacy';
import appearance from './appearance';
import trader from './trader';
import season from './season';
import guide from './guide';
import chains from './chains';
import radio from './radio';
import pit from './pit';
import market from './market';
// 20. 10. 2026 (owner): the Survivors list and the public profile.
import players from './players';

export default { common, onboarding, landing, camp, map, prepare, report, survivor, skills, inventory, workshop, feed, horde, encounter, clan, story, settings, events, collection, session, history, privacy, appearance, trader, season, guide, chains, radio, pit, market, players };
